import { render, staticRenderFns } from "./FormTabHeader.vue?vue&type=template&id=358961a3&scoped=true"
import script from "./FormTabHeader.vue?vue&type=script&lang=js"
export * from "./FormTabHeader.vue?vue&type=script&lang=js"
import style0 from "./FormTabHeader.vue?vue&type=style&index=0&id=358961a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358961a3",
  null
  
)

export default component.exports